import { render, staticRenderFns } from "./opening.vue?vue&type=template&id=6eb38124&scoped=true&"
import script from "./opening.vue?vue&type=script&lang=js&"
export * from "./opening.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=6eb38124&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb38124",
  null
  
)

export default component.exports